import StepperNavigation from "@/components/Navigation/StepperNavigation";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { useLocation } from "@tanstack/react-router";
import { ManualFormHash } from "../-constants/constant";
import { useAddNetworkFormStore } from "../-store/add-network-form-store";

const styleMap = {
  default: {
    card: "sticky h-full",
    vStack: "gap-2 my-1",
    link: "flex h-9 items-center rounded-md px-3 text-sm font-semibold transition-colors",
  },
};

export default function InnerNavigation() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages",
  });
  const styles = styleMap.default;
  const location = useLocation();
  const store = useAddNetworkFormStore();

  // 各ステップの完了状態を判定する関数
  const isStep1Complete = () => {
    return !!(
      store.networkName &&
      store.networkType &&
      store.connectionType &&
      store.networkCategory &&
      store.purpose
    );
  };

  const isStep2Complete = () => {
    // Step2は任意項目なので、何か1つでも入力されていれば完了とする
    return !!(
      store.accessLevel ||
      store.accessStatus ||
      store.accessPeriodStartDate ||
      store.accessPeriodEndDate ||
      store.subjectType
    );
  };

  // エラー状態を判定する関数
  const hasStep1Error = () => {
    return !!(
      store.errors.networkName ||
      store.errors.networkType ||
      store.errors.connectionType ||
      store.errors.networkCategory ||
      store.errors.purpose
    );
  };

  const hasStep2Error = () => {
    return !!(
      store.errors.accessLevel ||
      store.errors.accessStatus ||
      store.errors.accessPeriodStartDate ||
      store.errors.accessPeriodEndDate ||
      store.errors.subjectType
    );
  };

  const sectionMap = [
    {
      key: "networkInformation",
      href: `#${ManualFormHash.networkInformation}`,
      hash: ManualFormHash.networkInformation,
      label: t("networks.add.stepper.networkInformation"),
      completed: isStep1Complete(),
      error: hasStep1Error(),
    },
    {
      key: "accessControl",
      href: `#${ManualFormHash.accessControl}`,
      hash: ManualFormHash.accessControl,
      label: t("networks.add.stepper.accessControl"),
      completed: isStep2Complete(),
      error: hasStep2Error(),
    },
  ];

  return (
    <StepperNavigation
      className={styles.card}
      link={{
        hash: location.hash || ManualFormHash.networkInformation,
        to: "/networks/add",
      }}
      title={t("networks.add.title")}
      sections={sectionMap}
    />
  );
}
